/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Initial Admin API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Representation of an error which occurred on the server
 */
export interface ApiErrorResponseDTO { 
    /**
     * Trace identifier to easily find error on the server
     */
    traceId?: string;
    /**
     * Incident date time
     */
    timestamp?: string;
    /**
     * HTTP response code
     */
    status?: number;
    /**
     * Basic description of problem
     */
    message?: string;
    details?: Array<string>;
    /**
     * Request path
     */
    path?: string;
    error?: string;
    /**
     * * `ERR_0001_GENERAL_ERROR` - {} * `ERR_0002_UNHANDLED_ERROR` - Unhandled error occured. * `ERR_0003_PATH_DOES_NOT_EXIST` - Requested path [{} {}] does not exist * `ERR_0004_TYPE_MISMATCH` - Value {} is of wrong type * `ERR_0005_CONFLICT` - Conflict error. Reason: {} * `ERR_0007_FORBIDDEN` - Forbidden - The user does not have access to required resources. * `ERR_0008_ILLEGAL_ARGUMENT` - Illegal argument: {} * `ERR_0009_WRONG_DATA` - Wrong data provided * `ERR_0010_FIELD_VALUE_NOT_VALID` - Field {} of object {} has wrong value {}. Validation error {} * `ERR_0011_OBJECT_NOT_VALID` - Object {} is not valid. Validation error {} * `ERR_0012_MALFORMED_REQUEST` - Request data is not readable * `ERR_0013_CSV_PARSING` - Problem during parsing CSV file {}. Reason: {} * `ERR_0014_VALIDATION_ERROR` - Validation failed. Reason: {} * `ERR_0015_MISSING_REQUEST_PART` - Required request part \'{}\' is not present. * `ERR_0016_MANAGED_OBJECT_INVALID` - Managed object invalid. * `ERR_0017_ENTITY_NOT_FOUND` - Requested entity not found. * `ERR_0018_REQUEST_PROCESSING_FAILED` - Request processing failed: {} * `ERR_0019_OPTIMISTIC_LOCKING` - Optimistic locking failed. * `ERR_0020_ETAG_PRECONDITION_FAILED` - E-tag is missing or invalid: {}  * `NOTIFICATION_ERR_0001_NOTIFICATION_NOT_FOUND` - Notification not found: {} * `NOTIFICATION_ERR_0002_FILTER_NOTIFICATION_DATE_TO_INVALID` - Filter notificationDateTo has to be in past.  * `NOTIFICATION_ADMIN_ERR_0001_NOTIFICATION_NOT_EDITABLE` - Notification cannot be changed. 
     */
    code?: string;
}

export class ClsApiErrorResponseDTO { 
    /**
     * Trace identifier to easily find error on the server
     */
    traceId?: string = undefined;
    /**
     * Incident date time
     */
    timestamp?: string = undefined;
    /**
     * HTTP response code
     */
    status?: number = undefined;
    /**
     * Basic description of problem
     */
    message?: string = undefined;
    details?: Array<string> = undefined;
    /**
     * Request path
     */
    path?: string = undefined;
    error?: string = undefined;
    /**
     * * `ERR_0001_GENERAL_ERROR` - {} * `ERR_0002_UNHANDLED_ERROR` - Unhandled error occured. * `ERR_0003_PATH_DOES_NOT_EXIST` - Requested path [{} {}] does not exist * `ERR_0004_TYPE_MISMATCH` - Value {} is of wrong type * `ERR_0005_CONFLICT` - Conflict error. Reason: {} * `ERR_0007_FORBIDDEN` - Forbidden - The user does not have access to required resources. * `ERR_0008_ILLEGAL_ARGUMENT` - Illegal argument: {} * `ERR_0009_WRONG_DATA` - Wrong data provided * `ERR_0010_FIELD_VALUE_NOT_VALID` - Field {} of object {} has wrong value {}. Validation error {} * `ERR_0011_OBJECT_NOT_VALID` - Object {} is not valid. Validation error {} * `ERR_0012_MALFORMED_REQUEST` - Request data is not readable * `ERR_0013_CSV_PARSING` - Problem during parsing CSV file {}. Reason: {} * `ERR_0014_VALIDATION_ERROR` - Validation failed. Reason: {} * `ERR_0015_MISSING_REQUEST_PART` - Required request part \'{}\' is not present. * `ERR_0016_MANAGED_OBJECT_INVALID` - Managed object invalid. * `ERR_0017_ENTITY_NOT_FOUND` - Requested entity not found. * `ERR_0018_REQUEST_PROCESSING_FAILED` - Request processing failed: {} * `ERR_0019_OPTIMISTIC_LOCKING` - Optimistic locking failed. * `ERR_0020_ETAG_PRECONDITION_FAILED` - E-tag is missing or invalid: {}  * `NOTIFICATION_ERR_0001_NOTIFICATION_NOT_FOUND` - Notification not found: {} * `NOTIFICATION_ERR_0002_FILTER_NOTIFICATION_DATE_TO_INVALID` - Filter notificationDateTo has to be in past.  * `NOTIFICATION_ADMIN_ERR_0001_NOTIFICATION_NOT_EDITABLE` - Notification cannot be changed. 
     */
    code?: string = undefined;
}

